import { RouterProvider } from "react-router-dom";
import type { RouterProviderProps } from "react-router-dom";
import { BootDepsProvider } from "./lib/boot/deps";
import type { BootDeps } from "./lib/boot/deps";
import { PicoToastProvider } from "./components/PicoBubble";
import { DensityProvider, densityForSession } from "./store/density";
import { I18nProvider, resolveLocale } from "./i18n";
import type { SessionManager } from "./store/session/manager";
import { SessionProvider, useSession } from "./store/session/SessionProvider";

/** 세션 → 밀도·로캘을 전 화면에 전파한다(FS-01 에서 확정). */
function SessionScoped({ router }: { router: RouterProviderProps["router"] }) {
  const state = useSession();
  const session = state.status === "ready" ? state.session : null;
  const locale = resolveLocale(session?.locale);
  return (
    <I18nProvider locale={locale}>
      <DensityProvider auto={densityForSession(session)}>
        <PicoToastProvider>
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </PicoToastProvider>
      </DensityProvider>
    </I18nProvider>
  );
}

export function App({
  manager,
  deps,
  router,
}: {
  manager: SessionManager;
  deps: BootDeps;
  router: RouterProviderProps["router"];
}) {
  return (
    <SessionProvider manager={manager}>
      <BootDepsProvider deps={deps}>
        <SessionScoped router={router} />
      </BootDepsProvider>
    </SessionProvider>
  );
}
